module.exports = __webpack_public_path__ + "img/js6.afc49aba.jpg";